import { Statistic } from './statistics.model'

export const statistics: Statistic[] = [
  { value: '+9 mil', label: 'clientes atendidos' },
  { value: 'R$ 6 bilhões', label: 'em crédito originado' },
  { value: 'Nota 4,3', label: 'no Google Meu Negócio' }
]
